import React from 'react';
import { connect } from 'react-redux';
import EnumSelectorBase from './EnumSelectorBase';

const LocationTypeSelector = ({ value, setValue, sortOptions, renderOption, disabled }) => (
  <EnumSelectorBase
    name="Location Type"
    options={['ROOM', 'CORRIDOR', 'STAIRWELL', 'FLOOR'].sort(sortOptions)}
    getOptionLabel={(option) => option?.tagName || option}
    isOptionEqualToValue={(option, v) => option.id === v}
    value={value}
    onChange={setValue}
    renderOption={renderOption}
    disabled={disabled}
  />
);

export default connect()(LocationTypeSelector);
